// @flow
import React from 'react';

const LOGO_ARRAY = [];
LOGO_ARRAY.push(require('../assets/partner-logos/02.png'));
LOGO_ARRAY.push(require('../assets/partner-logos/03.png'));
LOGO_ARRAY.push(require('../assets/partner-logos/06.png'));
LOGO_ARRAY.push(require('../assets/partner-logos/07.png'));
LOGO_ARRAY.push(require('../assets/partner-logos/EMOMCo3.png'));
LOGO_ARRAY.push(require('../assets/partner-logos/GBRS_Group.png'));
LOGO_ARRAY.push(require('../assets/partner-logos/PerformanceExplored.png'));
LOGO_ARRAY.push(require('../assets/partner-logos/Coach-em-up-logo.png'));

export default function PartnerLogoFooter() {
    return (
        <div className="logo-container">
            {LOGO_ARRAY.map(logo => (
                <div>
                    <img data-testid="image" alt="Partner Logo" src={logo} />
                </div>
            ))}
        </div>
    );
}
